// Etiquetas contra o WootDash — /etiquetas. "description"/"showOnSidebar" replicam os
// mesmos campos do Chatwoot (adicionados a pedido, sem consumidor próprio ainda — só
// guardados e exibidos, igual no Chatwoot original). AppliesTo (Both/Chat/Contact) é
// conceito próprio do WootDash, sem equivalente direto. IsProtected é campo real do
// backend, agora setável pela própria tela de criação/edição — não mais um flag local em
// localStorage (useProtectedLabels.ts, só existia no admin antigo/Chatwoot).
import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

export type TagAppliesTo = 'Both' | 'Chat' | 'Contact'

export interface CpTag {
  id: string
  name: string
  color: string
  appliesTo: TagAppliesTo
  description: string | null
  showOnSidebar: boolean
  isProtected: boolean
}

function authHeaders(token: string, json = false) {
  return { ...wootdashAuthHeaders(token), ...(json ? { 'Content-Type': 'application/json' } : {}) }
}

export async function listTags(token: string): Promise<CpTag[]> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/etiquetas`, { headers: authHeaders(token) })
    if (!res.ok) return []
    return await res.json()
  } catch {
    return []
  }
}

export interface TagMutationResult { ok: boolean; failureReason?: string; tag?: CpTag }

export interface TagFormFields {
  description: string | null
  showOnSidebar: boolean
  isProtected: boolean
}

export async function createTag(
  token: string, name: string, color: string, appliesTo: TagAppliesTo, extra: TagFormFields,
): Promise<TagMutationResult> {
  const res = await fetch(`${WOOTDASH_BASE}/etiquetas`, {
    method: 'POST', headers: authHeaders(token, true),
    body: JSON.stringify({ name, color, appliesTo, description: extra.description, showOnSidebar: extra.showOnSidebar, isProtected: extra.isProtected }),
  })
  const data = await res.json().catch(() => undefined)
  return res.ok ? { ok: true, tag: data } : { ok: false, failureReason: data?.reason }
}

export async function updateTag(
  token: string, id: string, name: string, color: string, appliesTo: TagAppliesTo, extra: TagFormFields,
): Promise<TagMutationResult> {
  const res = await fetch(`${WOOTDASH_BASE}/etiquetas/${id}`, {
    method: 'PUT', headers: authHeaders(token, true),
    body: JSON.stringify({ name, color, appliesTo, description: extra.description, showOnSidebar: extra.showOnSidebar, isProtected: extra.isProtected }),
  })
  const data = await res.json().catch(() => undefined)
  return res.ok ? { ok: true, tag: data } : { ok: false, failureReason: data?.reason }
}

export async function deleteTag(token: string, id: string): Promise<{ ok: boolean; failureReason?: string }> {
  const res = await fetch(`${WOOTDASH_BASE}/etiquetas/${id}`, { method: 'DELETE', headers: authHeaders(token) })
  if (res.ok) return { ok: true }
  const data = await res.json().catch(() => undefined)
  return { ok: false, failureReason: data?.reason }
}
